import { useState, useEffect } from 'react';
import { Save, RefreshCw } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminSettings() {
  const [settings, setSettings] = useState({
    email: '',
    phone: '',
    address: '',
    company_name: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  const auth = localStorage.getItem('adminAuth');
  const config = { headers: { Authorization: `Basic ${auth}` } };

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${API}/admin/settings`, config);
      setSettings(res.data);
    } catch (err) {
      console.error('Error fetching settings:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccess(false);

    try {
      await axios.put(`${API}/admin/settings`, settings, config);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving settings:', err);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="text-text-secondary">Chargement...</div>;
  }

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-playfair text-3xl text-text-primary">Paramètres</h1>
        <p className="text-text-secondary mt-2">Configurer les informations du site</p>
      </div>

      <div className="max-w-2xl">
        <form onSubmit={handleSubmit} className="bg-surface-secondary border border-white/5 p-6 space-y-6">
          {success && (
            <div className="bg-green-900/20 border border-green-500/30 text-green-400 p-4 text-sm">
              Paramètres sauvegardés avec succès!
            </div>
          )}

          <div>
            <label className="block text-text-secondary text-sm mb-2">Nom de l'entreprise</label>
            <input
              type="text"
              value={settings.company_name}
              onChange={(e) => setSettings({...settings, company_name: e.target.value})}
              className="w-full bg-surface-tertiary border border-white/10 text-text-primary px-4 py-3 focus:outline-none focus:border-brand-gold/50"
            />
          </div>

          <div>
            <label className="block text-text-secondary text-sm mb-2">Adresse email</label>
            <input
              type="email"
              value={settings.email}
              onChange={(e) => setSettings({...settings, email: e.target.value})}
              className="w-full bg-surface-tertiary border border-white/10 text-text-primary px-4 py-3 focus:outline-none focus:border-brand-gold/50"
            />
          </div>

          <div>
            <label className="block text-text-secondary text-sm mb-2">Numéro de téléphone</label>
            <input
              type="tel"
              value={settings.phone}
              onChange={(e) => setSettings({...settings, phone: e.target.value})}
              className="w-full bg-surface-tertiary border border-white/10 text-text-primary px-4 py-3 focus:outline-none focus:border-brand-gold/50"
            />
          </div>

          <div>
            <label className="block text-text-secondary text-sm mb-2">Adresse</label>
            <textarea
              value={settings.address}
              onChange={(e) => setSettings({...settings, address: e.target.value})}
              rows={2}
              className="w-full bg-surface-tertiary border border-white/10 text-text-primary px-4 py-3 focus:outline-none focus:border-brand-gold/50"
            />
          </div>

          <div className="flex gap-4 pt-4">
            <button
              type="submit"
              disabled={saving}
              className="btn-primary inline-flex items-center gap-2 disabled:opacity-50"
            >
              {saving ? <RefreshCw size={18} className="animate-spin" /> : <Save size={18} />}
              {saving ? 'Sauvegarde...' : 'Sauvegarder'}
            </button>
          </div>
        </form>

        <div className="mt-8 p-6 bg-surface-secondary border border-white/5">
          <h3 className="font-playfair text-lg text-text-primary mb-4">Informations Admin</h3>
          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-text-secondary">Identifiant:</span>
              <span className="text-text-primary font-mono">admin</span>
            </div>
            <div className="flex justify-between">
              <span className="text-text-secondary">Mot de passe:</span>
              <span className="text-text-muted">••••••••••</span>
            </div>
            <p className="text-text-muted text-xs mt-4 pt-4 border-t border-white/10">
              Pour modifier les identifiants de connexion, contactez le développeur.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
